import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
`

export const SubStateText = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const ProvenanceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
`

export const ProvenanceMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const ProvenanceText = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: 1rem;
  align-items: start;
  width: 100%;
  margin-top: 1rem;

  @media (max-width: 70rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const ColumnStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
`

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem 1rem;
`

export const FieldCell = styled.div`
  min-width: 0;
`

export const FieldLabel = styled.span`
  display: block;
  margin-bottom: 0.25rem;
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
`

export const FieldValue = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.primary};
`

export const CalloutRow = styled.div<{ $tone: 'danger' | 'warning' }>`
  grid-column: 1 / -1;
  padding: 0.75rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${({ $tone }) => tokens.status[$tone].bg};
  color: ${({ $tone }) => tokens.status[$tone].fg};
  font-size: ${tokens.font.body};
  font-weight: 600;
`

export const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
`

export const HistoryItem = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0.75rem;
`

export const HistoryRail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
`

export const HistoryDot = styled.span`
  flex-shrink: 0;
  width: 0.5rem;
  height: 0.5rem;
  margin-top: 0.25rem;
  border-radius: 999px;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.strong};
`

export const HistoryStem = styled.span`
  width: 1px;
  flex: 1;
  min-height: 0.75rem;
  background: ${tokens.border.hairline};
`

export const HistoryBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-bottom: 1rem;
`

export const HistoryHead = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const HistoryTime = styled.span`
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const HistoryActor = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const TransitionWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`

export const StateChip = styled.span`
  padding: 0.125rem 0.375rem;
  border-radius: ${tokens.radius.chip};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.secondary};
`

export const TransitionArrow = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const HistoryNote = styled.span<{ $tone: 'danger' | 'warning' }>`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${({ $tone }) => tokens.status[$tone].fg};
`

export const TintedBlock = styled.div<{ $tone: 'danger' | 'warning' }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${({ $tone }) => tokens.status[$tone].bg};
`

export const TintedTitle = styled.span<{ $tone: 'danger' | 'warning' }>`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${({ $tone }) => tokens.status[$tone].fg};
`

export const TintedText = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`

export const ActionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`
